module.exports = __webpack_public_path__ + "static/hub-purple-e642d13fbd0026734088b7d3168c40f4.png";